import React, { useState, useEffect } from "react";
import { Clock } from "lucide-react";

const ZONES = {
  US: { label: "New York", tz: "America/New_York", flag: "US", accent: "#00E676" },
  IN: { label: "Mumbai",   tz: "Asia/Kolkata",      flag: "IN", accent: "#FFCC00" },
};

const _formatter = (tz) =>
  new Intl.DateTimeFormat("en-GB", {
    timeZone: tz,
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

const _dateFmt = (tz) =>
  new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    weekday: "short",
    day: "2-digit",
    month: "short",
  });

function ClockPill({ zone }) {
  const z = ZONES[zone];
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const time = _formatter(z.tz).format(now);
  const date = _dateFmt(z.tz).format(now);
  const hour = parseInt(_formatter(z.tz).format(now).split(":")[0], 10);
  // Market status — rough sessions
  let status = "Closed";
  let statusColor = "#71717A";
  if (zone === "US") {
    if (hour >= 9 && hour < 16) { status = "Open"; statusColor = "#00E676"; }
    else if (hour >= 4 && hour < 9) { status = "Pre"; statusColor = "#FFCC00"; }
    else if (hour >= 16 && hour < 20) { status = "After"; statusColor = "#FFCC00"; }
  } else if (zone === "IN") {
    if (hour >= 9 && hour < 16) { status = "Open"; statusColor = "#00E676"; }
    else if (hour >= 7 && hour < 9) { status = "Pre"; statusColor = "#FFCC00"; }
  }

  return (
    <div data-testid={`live-clock-${zone.toLowerCase()}`} className="flex items-center gap-2 px-3 py-1.5 rounded-sm bg-zinc-900/60 border border-zinc-800 backdrop-blur-sm">
      <span className="font-mono text-[10px] font-semibold tracking-wider text-zinc-500">{z.flag}</span>
      <div className="flex flex-col leading-tight">
        <span className="font-mono text-sm font-bold tabular-nums" style={{ color: z.accent }}>{time}</span>
        <span className="font-mono text-[9px] text-zinc-500 uppercase tracking-wider">{date}</span>
      </div>
      <span className="font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm" style={{ color: statusColor, background: `${statusColor}15`, border: `1px solid ${statusColor}30` }}>{status}</span>
    </div>
  );
}

export default function LiveClock({ zones = ["US", "IN"], compact = false }) {
  return (
    <div data-testid="live-clock" className={`flex items-center gap-2 ${compact ? "" : "flex-wrap"}`}>
      {!compact && <Clock className="w-3.5 h-3.5 text-zinc-500" />}
      {zones.map(z => <ClockPill key={z} zone={z} />)}
    </div>
  );
}
